import { Box, Typography, Container, SxProps, Theme } from "@mui/material";

export const Hero = () => {
  return (
    <Box sx={heroSx}>
      <Container maxWidth="lg">
        <Box sx={heroContentSx}>
          <Typography variant="h1" sx={heroTitleSx}>
            <Typography sx={heroTitleHeadSx} display="inline" variant="inherit">
              T
            </Typography>
            echnical Assist Service (TAS)
          </Typography>
          <Typography variant="h2" sx={heroSubtitleSx}>
            システム開発を効率化する革新的なサービス
          </Typography>
          <Typography variant="body1" sx={heroDescriptionSx}>
            テクニカルアシストサービスは、システム開発に必要な幅広い技術スキルを持つエンジニアを、プロジェクトの状況に応じて
            <strong>柔軟に組み替え</strong>、各フェーズに<strong>最適な体制</strong>で開発を進めるサービスです。
          </Typography>
          <Typography variant="body1" sx={heroDescriptionSx}>
            <strong>副業人材</strong>と<strong>専業人材</strong>
            をバランスよく組み合わせることで、コストと柔軟性を確保しつつ、<strong>高度な専門性を備えたチーム</strong>
            を編成。
            <br />
            要件定義から設計、実装、テスト、運用まで、開発プロセス全体を的確にサポートし、
            <strong>質の高い成果を生み出します</strong>。
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

const heroSx: SxProps<Theme> = (theme) => ({
  width: "100%",
  background: "rgba(34, 161, 185, 0.1)",
  padding: "60px 0",
  textAlign: "center",
  position: "relative",
  overflow: "hidden",
});

const heroContentSx: SxProps<Theme> = {
  position: "relative",
  zIndex: 2,
};

const heroTitleSx: SxProps<Theme> = (theme) => ({
  justifyContent: "center",
  alignItems: "center",
  fontFamily: "Avenir Next",
  fontWeight: 500,
  fontSize: {
    md: "64px",
    xs: "40px",
  },
  padding: "20px 0",
});

const heroTitleHeadSx: SxProps<Theme> = (theme) => ({
  color: "#22A1B9",
  fontWeight: 700,
});

const heroSubtitleSx: SxProps<Theme> = (theme) => ({
  fontSize: "1.4rem",
  marginBottom: "40px",
  color: "#22A1B9",
  fontWeight: 600,
  [theme.breakpoints.down("md")]: {
    fontSize: "1.2rem",
  },
});

const heroDescriptionSx: SxProps<Theme> = {
  fontSize: "1.1rem",
  marginBottom: "30px",
  opacity: 0.9,
  maxWidth: "700px",
  marginLeft: "auto",
  marginRight: "auto",
};
